<template>
    <div>
      <!-- 상단 SubTab 영역 -->
      <ul v-if="filterList" class="cs-2depth">
        <template v-for="(filterItem, index) in filterList">
          <li :key="index" @click="goFilterPage(filterItem.type)" :class="setTabCss(filterItem.type)"><button>{{filterItem.title}}</button></li>
        </template>
      </ul>

      <div class="cs-table02-wrap">
        <form class="noti-search">
          <fieldset>
            <legend>공지사항 검색 양식</legend>
            <label>
              <input type="text"
                     @keydown.enter.prevent="goSearchWord()"
                     v-on:input="searchWord = $event.target.value"
                     :value="searchWord"
                     placeholder="궁금하신 점을 입력해 주세요" />
            </label>
            <button type="button" @click="goSearchWord()" class="noti-search-btn">검색</button>
          </fieldset>
        </form>

        <template v-if="!isLoading">
          <table v-if="noticeList.length > 0" class="cs-table-02">
            <caption>공지사항 리스트 </caption>
            <colgroup>
              <col style="width: 139px;">
              <col>
              <col style="width: 139px;">
            </colgroup>
            <thead>
            <tr>
              <th>구분</th>
              <th>제목</th>
              <th>등록일</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(noticeItem, index) in noticeList">
              <tr :key="index" :class="setTopCss(noticeItem.istop)">
                <td><p class="noti-type">{{noticeItem.noticetypetext}}</p></td>
                <td>
                  <a href="#" @click.prevent="goDetailPage(noticeItem.noticeid)">
                    <span v-html="setWordChange(noticeItem.noticetitle)"></span>
                  </a>
                  <span v-if="noticeItem.isNew === 'y'" class="badge ui">NEW</span>
                <td><p class="noti-date">{{noticeItem.regdate}}</p></td>
              </tr>
            </template>
            </tbody>
          </table>
          <div v-else class="cs-empty">
            <img src="../../assets/images/customer/icon-error-74.png" alt="에러 아이콘"/>
            <p>'<span class="col-purple">{{$route.query.searchWord}}</span>'에 대한 공지사항이 없습니다.</p>
          </div>
        </template>
      </div>
      <paging-component v-if="noticeList.length > 0" :current-page="currentPage" :page-count="totalCount" :limit="limit" :paging-count="pagingCnt" wrapper-class="paging-type02" />
    </div>
</template>

<script>
import PagingComponent from '@/components/common/PagingComponent'
import { setReplaceAll, scrollTop, titleTagNameChange } from '@/common/utils/common'
import { getNotices, getSearchNotice } from '@/common/utils/request'
import queryString from '@/common/utils/querystring'
import _ from 'lodash'

export default {
  name: 'NoticeList',
  components: {
    PagingComponent // 페이징
  },
  data () {
    return {
      data: true, // 임시 웨이브온 flag 값
      filterType: queryString.getQueryParamValue(this.$route, 'filterType', 'all'),
      filterList: [
        { title: '전체', type: 'all' },
        { title: '서비스공지', type: 'service' },
        { title: '콘텐츠공지', type: 'contents' }
      ],
      searchWord: queryString.getQueryParamValue(this.$route, 'searchWord', ''),
      noticeList: [],
      isLoading: true,
      offset: 0,
      limit: 10,
      totalCount: 0,
      currentPage: +queryString.getQueryParamValue(this.$route, 'page', '1'), // 현재 페이지
      pagingCnt: 10 // 한 페이지당 출력할 페이징 수
    }
  },
  methods: {
    // 공지사항 리스트 조회
    getNoticeList (pagenum) {
      this.isLoading = true
      const offset = (pagenum - 1) * this.limit
      const getData = response => response.data
      const getTotalCount = data => { this.totalCount = Number(_.get(data, 'pagecount', 1)); return data }
      const getNoticeList = data => {
        this.noticeList = _.get(data, 'list', []).map((titleItem) => {
          return _.set(titleItem, _.get(titleItem, 'noticetitle', ''), _.get(titleItem, 'noticetitle', '').replace(RegExp('<', 'g'), '&lt;').replace(RegExp('>', 'g'), '&gt;'))
        }); return data
      }
      const loadComplete = () => { this.isLoading = false }

      if (this.searchWord && this.searchWord !== '') {
        getSearchNotice({ type: this.filterType, keyword: this.searchWord, offset, limit: this.limit, orderby: this.orderby })
          .then(getData).then(getTotalCount).then(getNoticeList).then(loadComplete)
      } else {
        getNotices({ type: this.filterType, top: 'all', offset, limit: this.limit, orderby: this.orderby })
          .then(getData).then(getTotalCount).then(getNoticeList).then(loadComplete)
      }
    },
    // SubTab CSS 설정
    setTabCss (tempId) {
      return this.filterType === tempId ? 'cs-2depth-on' : ''
    },
    setTopCss (istop) {
      return istop === 'y' ? 'noti-top' : ''
    },
    // 검색 단어 변경
    setWordChange (content) {
      const querySearchWord = _.get(this.$route, 'query.searchWord', '')
      let changeWord = '<span class="col-purple">' + querySearchWord + '</span>'
      let tmpContent = content
      if (querySearchWord !== '') {
        const searchWord = querySearchWord.toUpperCase()
        tmpContent = setReplaceAll(content, searchWord, changeWord)
      }
      return tmpContent
    },
    // Filter 선택 페이지 이동
    goFilterPage (tempId) {
      this.$router.push({ query: { filterType: tempId } })
    },
    // 검색어 조회 페이지 이동
    goSearchWord () {
      this.$router.push({
        name: 'notice_list',
        query: {
          filterType: this.filterType,
          searchWord: this.searchWord
        }
      })
    },
    // 공지사항 상세 페이지 이동
    goDetailPage (noticeId) {
      this.$router.push({
        name: 'notice_view',
        query: {
          filterType: this.filterType,
          noticeId: noticeId,
          pageNum: this.currentPage,
          searchWord: this.searchWord
        }
      })
    }
  },
  created () {
    scrollTop()
    // 공지사항 리스트 조회
    this.getNoticeList(this.currentPage)
    titleTagNameChange('공지사항 : 웨이브 고객센터')
  },
  watch: {
    $route () {
      this.filterType = _.get(this.$route, ['query', 'filterType'], 'all')
      this.currentPage = parseInt(_.get(this.$route, ['query', 'page'], '1'))
      this.searchWord = _.get(this.$route, ['query', 'searchWord'], '')
      this.getNoticeList(this.currentPage)
    }
  },
  filters: {
    stringTag (value) {
      let span = document.createElement('span')
      span.innerHTML = value
      return span.textContent || span.innerText || ''
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/member.scss"></style>
<style lang="scss" src="@/assets/scss/category/service.scss"></style>
